import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-measure-button',
	standalone: true,
	imports: [TranslateModule],
	templateUrl: './measure-button.component.html',
	styleUrl: './measure-button.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasureButtonComponent {}
